import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';

export const getServiceResponseRate = () => {
    const config = {
        path: 'DashboardMassiveService/response-rate',
        method: 'GET'
    };
    return FetchByObjectConfig(config);
}

